// extracted by mini-css-extract-plugin
export default {"option":"style_option__hCmkS"};